import * as React from 'react';
import * as styles from './AnimationFade.css';
import { CSSTransition } from 'react-transition-group';
import { jsx as _jsx } from "react/jsx-runtime";
export function AnimationFade(_ref) {
  var show = _ref.show,
    children = _ref.children;
  return /*#__PURE__*/_jsx(CSSTransition, {
    in: show,
    timeout: 300,
    unmountOnExit: true,
    classNames: {
      enter: styles['notification__animation-enter'],
      enterActive: styles['notification__animation-enter-active'],
      exit: styles['notification__animation-leave'],
      exitActive: styles['notification__animation-leave-active']
    },
    children: children
  });
}